const DAYS_SHORT = "日月火水木金土祝";

/**
 * 週の文字
 * @param dayOfWeekNumber 週の番号
 */
export default function dayOfWeek(dayOfWeekNumber: number): string {
  // return locale.localize.day(dayOfWeekNumber, { width: "narrow" });
  return DAYS_SHORT[dayOfWeekNumber];
}
